import axios from 'axios'
import store from "@/store"

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/'

const authApiBaseUrl = axios.create({
	baseURL: process.env.VUE_APP_AUTH_API_BASE_URL + '/'
})

//FOR INTERNAL USE ONLY IN LEAD FORM
const axiosInternal = axios.create({
	baseURL: process.env.VUE_APP_API_BASE_URL + "/",
});

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    const token = store.state.auth.accessToken;
    
    config.headers = {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        ...config.headers
    };

    // If Content-Type is not set, and data is not a FormData object, default to application/json
    if (!config.headers['Content-Type'] && !(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json';
    } else if (config.data instanceof FormData) {
        // Delete Content-Type to allow browser/Axios to set it with correct multipart boundary
        delete config.headers['Content-Type'];
    }
     
    return config
})

axios.interceptors.response.use(
	function (response) {
		return response;
	},
	async function (error) {
		const originalRequest = error.config;

		if (error.response && error.response.status === 401 && !originalRequest._retry) {
			store.commit("auth/setIsTokenExpired");
			store.dispatch("auth/logout");
		}

		//parse error message when response type is blob
		if (
			error.request &&
			error.request.responseType === "blob" &&
			error.response &&
			error.response.data instanceof Blob &&
			error.response.data.type &&
			error.response.data.type.toLowerCase().indexOf("json") != -1
		) {
			return new Promise((resolve, reject) => {
				let reader = new FileReader();
				reader.onload = () => {
					error.response.data = JSON.parse(reader.result);
					resolve(Promise.reject(error));
				};

				reader.onerror = () => {
					reject(error);
				};

				reader.readAsText(error.response.data);
			});
		}

		return Promise.reject(error);
	}
)

// ===== AUTH API =====
// Add a request interceptor
authApiBaseUrl.interceptors.request.use(function (config) {
	const token = store.state.auth.accessToken;
	config.headers = {
		Authorization: `Bearer ${token}`,
		Accept: "application/json",
		"Content-Type": "application/json",
	};

	return config;
});

authApiBaseUrl.interceptors.response.use(
	function (response) {
		return response;
	},
	async function (error) {
		const originalRequest = error.config;

		if (error.response.status === 401 && !originalRequest._retry) {
			store.commit("auth/setIsTokenExpired");
			store.dispatch("auth/logout");
		}

		return Promise.reject(error);
	}
);

// ===== NON-AUTH API =====
// Add a request interceptor
axiosInternal.interceptors.request.use(function (config) {
	config.headers = {
		Accept: "application/json",
		"Content-Type": "application/json",
	};

	return config;
});

export default {
   install: (app) => {
      app.config.globalProperties.$axios = axios
		app.config.globalProperties.$axios_auth = authApiBaseUrl
		app.config.globalProperties.$axios_internal = axiosInternal;
   }
}